import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队精心挑选的必看漫画专题</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group cursor-pointer bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={`女神漫画 ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-500">{item.subtitle}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}